<template>
  <b-card class="mb-3 d-md-block" no-body :key="rerender">
    <b-card-body style="padding-bottom: 0.2rem;">
      <div class="d-flex flex-wrap justify-content-between">
        <h4 class="card-title mb-0">Статистика по олимпиадам
          <em class="fas fa-info-circle info-for-link" v-b-tooltip.hover title=
            "На графике предусмотрены подсказки при наведении с указанием класса и значения."
          style="color: #0078c1;"></em>
        </h4>
        <div class="ml-auto mb-2">
          <b-btn variant="primary"
                 class="addButton ml-1 mt-1 align-items-center"
                 v-b-modal.addOlympiadModal
          >
            <em class="fas fa-plus send-icon mr-1"></em>Добавить
          </b-btn>
          <b-btn
            variant="outline-danger"
            class="addButton ml-1 mt-1 align-items-center"
            v-b-modal.delete-confirmation-modal
          >
            <em class="fas fa-times-circle mr-1"></em> Удалить
          </b-btn>
        </div>
      </div>
    </b-card-body>
    <b-card-body class="pl-0" id="card-for-olymp-stats-body">
      <div class="map-container ml-3">
        <label>Выберите олимпиаду</label>
        <b-form-select v-model="selected" class="mb-2" @input="onChangeOlymp">
          <optgroup v-for="(years, index) in olympicsYears" :label="years" :key="index">
            <option v-for="(olymp, index) in olympics.filter((p) => p.years
                    === years)" :value="olymp.id" :key="index">{{olymp.title}}</option>
          </optgroup>
        </b-form-select>
        <div v-if="statsOlympicsResults.length">
          <div v-if="windowWidth >= 1250">
            <h5
              :class="!showAverageProgress ? 'olympic-stats-header-full' : 'olympic-stats-header'"
            >
              Процент участников
              <em class="fas fa-info-circle info-for-link" v-b-tooltip.hover title=
                "Процент участников заключительного этапа олимпиады от общей
                численности обучающихся в классе за год проведения олимпиады"
                style="color: #0078c1;"></em></h5>
            <h5
              v-if="showAverageProgress"
              class="olympic-stats-header"
            >
              Средний балл
              <em
                class="fas fa-info-circle info-for-link"
                v-b-tooltip.hover title=
                  "Средний балл среди участников заключительного этапа по каждому классу"
                style="color: #0078c1;"
              ></em>
            </h5>
          </div>
          <h5
            v-if="windowWidth < 1250"
            :class="!showAverageProgress ? 'olympic-stats-header-full' : 'olympic-stats-header'"
          >
            Процент участников
          </h5>
          <div class="div-for-olymp-stats" v-if="olympStatLoaded && showAverageProgress">
            <polar-area type-stats="count" :selected-olymp="selecetedOlympId"></polar-area>
          </div>
          <div v-else-if="olympStatLoaded">
            <b-row>
              <b-col sm="3"></b-col>
              <b-col sm="6">
                <polar-area type-stats="count" :selected-olymp="selecetedOlympId"></polar-area>
              </b-col>
              <b-col sm="3"></b-col>
            </b-row>
          </div>
          <h5
            v-if="windowWidth < 1250 && showAverageProgress"
            class="mt-2 olympic-stats-header"
          >
            Средний балл
          </h5>
            <div class="div-for-olymp-stats" v-if="olympStatLoaded && showAverageProgress">
              <polar-area type-stats="progress" :selected-olymp="selecetedOlympId"></polar-area>
            </div>
        </div>
      </div>
    </b-card-body>
    <b-card-body class="pl-0">
      <div class="d-flex flex-wrap justify-content-between">
        <h5 class="ml-4">Результаты по всем классам</h5>
        <div class="ml-auto mb-2">
          <b-btn
            variant="outline-primary"
            class="addButton align-items-center"
            v-on:click="onEditGridClicked"
            v-if="isEditVisible"
          >
          <em class="fas fa-edit mr-1"></em> Редактировать
          </b-btn>
          <b-btn
            variant="outline-primary"
            class="addButton align-items-center ml-1 mb-1"
            v-on:click="onSaveGridClicked"
            v-if="!isEditVisible"
          >
            <em class="fas fa-check mr-1"></em> Сохранить изменения
          </b-btn>
          <b-btn
            variant="outline-primary"
            title="Просмотр отличия заполненных данных и данных из системы олимпиад"
            class="addButton align-items-center mb-1"
            v-b-modal.olympic-diffs-modal
            v-if="!isEditVisible && isChangesAvailable"
          >
            <em class="fas fa-exchange-alt mr-1"></em> Сравнение
          </b-btn>
        </div>
      </div>
      <b-alert variant="warning" show=""  v-if="!isEditVisible" class="warning-message">
        Вы находитесь в режиме редактирования. Не забудьте <strong>сохранить изменения</strong>!
      </b-alert>
      <ag-grid-vue
        class="ag-theme-material ag-grid-for-olymp-stat"
        :columnDefs="columnDefs"
        :gridOptions="gridOptions"
        :rowData="rowData"
        @grid-ready="onGridReady"
        @gridSizeChanged="onGridSizeChanged"
        @rowDataChanged = "onRowDataChanged"
        @column-resized="onColumnResized">
      </ag-grid-vue>
    </b-card-body>
    <add-olympiad-modal></add-olympiad-modal>
    <b-modal id="delete-confirmation-modal" hide-footer centered hide-backdrop>
      <template slot="modal-title">
        Удаление олимпиады из статистики
      </template>
      <p class="my-1 text-center">
        Вы уверены, что хотите удалить статистику данной олимпиады из системы?
      </p>
      <b-row class="mt-4">
        <b-col>
          <b-button block variant="primary" @click="onDelete">
            Удалить
          </b-button>
        </b-col>
        <b-col>
          <b-button block variant="outline-primary"
                    @click="$bvModal.hide('delete-confirmation-modal')">
            Отмена
          </b-button></b-col>
      </b-row>
    </b-modal>
    <OlympicDiffsModal :olymp-title="isChangesAvailable ? currentOlympicTitle : null"/>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { AgGridVue } from 'ag-grid-vue'
import PolarArea from '@/components/statistic/PolarArea.vue'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import AddOlympiadModal from '@/components/statistic/modals/AddOlympiadModal.vue'
import statisticsApi from '@/api/statistics'
import OlympicDiffsModal from '@/components/statistic/modals/OlympicDiffsModal.vue'


export default {
  name: 'OlympicStats',
  props: {
    loaded: {
      type: Boolean,
      default: false
    }
  },
  components: {
    OlympicDiffsModal,
    PolarArea,
    AgGridVue,
    AddOlympiadModal
  },
  data() {
    return {
      isChangesAvailable: false,
      olympStatLoaded: false,
      showAverageProgress: false,
      selected: null,
      selecetedOlympId: null,
      windowWidth: null,
      rowData: null,
      columnDefs: [
        {
          headerName: 'Класс',
          field: 'title',
          suppressSizeToFit: false,
          width: 170,
          minWidth: 170
        },
        {
          headerName: 'Зарегистрировано в олимпиаде',
          field: 'registered'
        },
        {
          headerName: 'Участники заключительного этапа',
          field: 'membersOlymp'
        },
        {
          headerName: 'Призёры',
          field: 'semiwinners',
          width: 115
        },
        {
          headerName: 'Победители',
          field: 'winners',
          width: 140
        }
      ],
      rerender: false,
      gridApi: null,
      isEditVisible: true,
      gridOptions: {
        defaultColDef: {
          autoHeight: true,
          lockPosition: true,
          headerClass: 'table-olymp-stats-header',
          sortable: true,
          suppressSizeToFit: true,
          width: 180
        },
        localeText: AG_GRID_LOCALE_RU,
        headerHeight: 80,
        enableCellTextSelection: true,
        suppressMenuHide: true
      }
    }
  },
  beforeMount() {
    this.windowWidth = window.innerWidth
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  },
  async mounted() {
    await this.fetchOlympics()
    await this.fetchGPClasses()

    let i = 0
    this.selected = this.olympics[i].id
    await this.onChangeOlymp()
    while (!this.statsOlympicsResults.some((r) => r.membersOlymp > 0)) {
      i += 1
      this.selected = this.olympics[i].id
      // eslint-disable-next-line no-await-in-loop
      await this.$nextTick()
      // eslint-disable-next-line no-await-in-loop
      await this.onChangeOlymp()
    }
  },
  methods: {
    ...mapActions({
      fetchStatsOlympicsResults: 'statistics/fetchStatsOlympicsResults',
      updateStatsOlympicsResults: 'statistics/updateStatsOlympicsResults',
      fetchGPClasses: 'content/fetchGPClassesForMap',
      fetchOlympics: 'dicts/fetchOlympics',
      pushToasts: 'toasts/pushToasts'
    }),
    async onEditGridClicked() {
      this.columnDefs = this.columnDefs
        .map((col) => (col.field === 'title' ? { ...col } : { ...col, editable: true }))
      await this.gridApi.resetRowHeights()
      this.gridApi.sizeColumnsToFit()
      this.isEditVisible = !this.isEditVisible
    },
    async onSaveGridClicked() {
      await Promise.resolve(
        this.updateStatsOlympicsResults({ olympiadId: this.selected, newData: this.rowData }),
      ).then(() => {
        this.pushToasts({
          title: 'Уведомление',
          message: 'Обновление статистики произошло успешно'
        })
      })
        .catch((error) => {
          this.pushToasts({
            title: 'Ошибка',
            error: true,
            message: 'При обновлении статистики произошла ошибка'
          })
          console.log(error)
        })
      this.columnDefs = this.columnDefs
        .map((col) => ({ ...col, editable: false }))
      await this.gridApi.resetRowHeights()
      this.gridApi.sizeColumnsToFit()
      this.isEditVisible = !this.isEditVisible
    },
    async onDelete() {
      this.$bvModal.hide('delete-confirmation-modal')
      await Promise.resolve(statisticsApi.deleteOlympiad(this.selecetedOlympId))
        .then(() => {
          this.pushToasts({
            title: 'Уведомление',
            message: 'Удаление олимпиады произошло успешно'
          })
        })
        .catch((error) => {
          this.pushToasts({
            title: 'Ошибка',
            error: true,
            message: 'При удалении олимпиады произошла ошибка'
          })
          console.log(error)
        })
      this.fetchOlympics()
      this.fetchGPClasses().then(() => {
        this.selected = this.olympics[0].id
        const tableData = this.statsOlympicsResults
        tableData.forEach((td) => {
          td.title = this.orgs.filter((p) => p.id
            === td.organizationId)[0].title
        })
        this.rowData = tableData
        if (this.statsOlympicsResults.find((res) => res.averageProgress > 0)) {
          this.showAverageProgress = true
        }
      })
    },
    async onChangeOlymp() {
      const selectedOlymp = this.olympics.find((ol) => ol.id === this.selected)
      this.isChangesAvailable = selectedOlymp
        && this.olympicsYears.length
        && selectedOlymp.years === this.olympicsYears[0]
      await this.fetchStatsOlympicsResults(this.selected)
      this.selecetedOlympId = this.selected
      const tableData = this.statsOlympicsResults
      tableData.forEach((td) => {
        const org = this.orgs.find((p) => p.id === td.organizationId && p.position && td.membersClass)
        if (org) {
          const cityStr = (org.city && !!org.city.trim()) ? `${org.city}, ` : ''
          td.title = cityStr + org.title
        } else {
          td.oldData = true
        }
      })
      this.rowData = tableData.filter((td) => !td.oldData)
      this.showAverageProgress = !!(this.statsOlympicsResults
        .find((res) => res.averageProgress > 0))
      this.olympStatLoaded = true
    },
    onColumnResized() {
      this.gridApi.resetRowHeights()
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.gridApi.sizeColumnsToFit()
    },
    onGridSizeChanged() {
      this.gridApi.sizeColumnsToFit()
    },
    onRowDataChanged() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit()
      }
    },
    async fetchStats(selected) {
      this.selected = selected
      await this.fetchOlympics()
      await this.onChangeOlymp()
      await this.fetchGPClasses()
      const tableData = this.statsOlympicsResults
      tableData.forEach((td) => {
        td.title = this.orgs.filter((p) => p.id
        === td.organizationId)[0].title
        this.rowData = tableData
        if (this.statsOlympicsResults.find((res) => res.averageProgress > 0)) {
          this.showAverageProgress = true
        }
      })
      this.rerender = !(this.rerender)
    }
  },
  computed: {
    ...mapGetters({
      olympics: 'dicts/getOlympics',
      orgs: 'dicts/getOrganizations',
      statsOlympicsResults: 'statistics/getStatsOlympicsResults'
    }),
    currentOlympicTitle() {
      const olympiad = this.olympics.find((ol) => ol.id === this.selected)
      return olympiad ? olympiad.title : ''
    },
    olympicsYears() {
      const olympYears = []
      if (this.olympics) {
        this.olympics.forEach((ol) => {
          if (!olympYears.includes(ol.years)) {
            olympYears.push(ol.years)
          }
        })
      }
      return olympYears
    }
  }
}
</script>

<style>
  .olympic-stats-header {
    text-align: center;
  }
  .olympic-stats-header-full {
    text-align: center;
    width: 100%;
  }
  @media screen and (min-width: 1250px) {
    .div-for-olymp-stats, .olympic-stats-header{
      width: 50%;
      display: inline-block;
    }
  }
  .ag-grid-for-olymp-stat {
    height: 500px;
    border-bottom: 1px solid #017ac3;
    margin-left: 20px;
  }
  .ag-grid-for-olymp-stat .ag-header-cell-label .ag-header-cell-text {
    height: auto;
    white-space: normal;
    word-wrap: break-word;
    text-align: center;
  }
  .ag-grid-for-olymp-stat .ag-icon {
    color: #017ac3;
  }

  .ag-grid-for-olymp-stat .ag-header-viewport {
    border-top: 1px solid #017ac3;
    border-bottom: 1px solid #017ac3;
  }

  .table-olymp-stats-header{
    font-size: 14px;
    color: #017ac3;

  }

  .warning-message {
    margin-left: 20px;
  }

  .addButton {
    display: flex;
    flex-direction: row;
    float: right;
  }
</style>
